import React, { useEffect, useState, useRef, useCallback } from 'react';
import "../css/others/Popup.css"
import { ToastPopupProps } from "../Interfaces/Interface";
const ToastPopup: React.FC<ToastPopupProps> = ({ message, type = 'success', onClose, duration = 3000 }) => {
    const [hovering, setHovering] = useState(false);
    const timerStartRef = useRef<number>(Date.now());
    const timerRemainingRef = useRef<number>(duration);
    const timeoutRef = useRef<NodeJS.Timeout | null>(null);
    const clearTimer = useCallback(() => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
    }, []);
    const startTimer = useCallback(() => {
        clearTimer();
        timerStartRef.current = Date.now();
        timeoutRef.current = setTimeout(onClose, timerRemainingRef.current);
    }, [clearTimer, onClose]);
    useEffect(() => {
        timerRemainingRef.current = duration;
        startTimer();
        return clearTimer;
    }, [duration, startTimer, clearTimer]);
    const handleMouseEnter = () => {
        setHovering(true);
        clearTimer();
        const elapsed = Date.now() - timerStartRef.current;
        timerRemainingRef.current = Math.max(0, timerRemainingRef.current - elapsed);
    };
    const handleMouseLeave = () => {
        setHovering(false);
        startTimer();
    };
    const renderTitle = () => {
        switch (type) {
            case 'error':
                return (
                    <span>
                        <span className="toast-error">❌</span> Error
                    </span>
                );
            case 'warning':
                return (
                    <span>
                        <span className="toast-warning">⚠️</span> Warning
                    </span>
                );
            default:
                return (
                    <span>
                        <span className="toast-success">✅</span> Success
                    </span>
                );
        }
    };
    return (
        <div className={`toast-popup ${type}`} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
            <div className="toast-header">
                <span>{renderTitle()}</span>
                <button className="close" onClick={onClose}>×</button>
            </div>
            <div className="toast-body">{message}</div>
            <div className="progress-bar" style={{ animationDuration: `${duration}ms`, animationPlayState: hovering ? 'paused' : 'running' }} />
        </div>
    );
};
export default ToastPopup;